import { render } from "./propertiesPrint.vue?vue&type=template&id=77593796"
import script from "./propertiesPrint.vue?vue&type=script&lang=js"
export * from "./propertiesPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__